import { IconButton, IconButtonProps } from '@mui/material';
import CloseMuiIcon from '@mui/icons-material/Close';
import React from 'react';

type CloseIconProps = IconButtonProps & {
  'data-testid'?: string;
};

export const CloseIcon = ({ onClick, ...props }: CloseIconProps) => {
  return (
    <IconButton
      onClick={onClick}
      {...props}
      sx={{
        width: '44px',
        height: '44px',
        borderRadius: '6px',
        minWidth: 'auto',

        '& svg': {
          width: '24px',
          height: '24px',
        },
        ...props.sx,
      }}
    >
      <CloseMuiIcon color="inherit" />
    </IconButton>
  );
};
